import React, { useEffect, useState } from 'react';
import { NavigationStepperItemType } from './NavigationStepper';
import NavigationStepperItem from './NavigationStepperItem';
// @ts-ignore
import styles from './NavigationStepperItems.module.scss';
import { joinClasses } from '../../Utils/className.util';

export interface NavigationStepperItemsProps {
	activeKey?: string;
	items: NavigationStepperItemType[];
	onChange: (step: NavigationStepperItemType) => void;
	routes?: NavigationStepperItemType[];
	firstUpper?: boolean;
	showStepNumbers?: boolean;
	className?: string;
}

const NavigationStepperItems: React.FC<NavigationStepperItemsProps> = props => {
	const { items, onChange, activeKey, showStepNumbers, className } = props;
	const [steps, setSteps] = useState<NavigationStepperItemType[]>([]);

	useEffect(() => {
		let disableUntilIndex: number | null = null;
		const tempItems: NavigationStepperItemType[] = [];

		items.map((item: NavigationStepperItemType, index: number) => {
			if (item.cantGoBack && item.key === activeKey) {
				disableUntilIndex = index;
				return;
			}
		});

		items.map((item: NavigationStepperItemType, index: number) => {
			const tempItem = item;
			if (disableUntilIndex) {
				if (index < disableUntilIndex + 1) {
					tempItem['disabled'] = true;
				}
			}
			tempItems.push(tempItem);
		});

		setSteps(tempItems);
	}, [items, activeKey]);

	return (
		<div className={joinClasses([styles.itemsWrapper, className])}>
			<div className={styles.items}>
				{steps.map((item: NavigationStepperItemType, index: number) => (
					<NavigationStepperItem
						item={item}
						key={index}
						onChange={onChange}
						activeKey={activeKey}
						showStepNumbers={showStepNumbers}
					/>
				))}
			</div>
		</div>
	);
};

export default NavigationStepperItems;
